import React from 'react';
import {
	FontAwesomeIcon,
} from '@fortawesome/react-fontawesome';
import {
	library,
} from '@fortawesome/fontawesome-svg-core';
import {
	fas,
} from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

library.add(fas, far);

function CustomIcon (props) {

	let icon = '';
	switch (props.icon) {
	case '4k':
		break;
	case 'horizontal':
		icon = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" >
			<path className="monitorShape" d="M446.4,378.37H50.07c-9.44,0-17.09-7.65-17.09-17.09V110.32c0-9.44,7.65-17.09,17.09-17.09H446.4 c9.44,0,17.09,7.65,17.09,17.09v250.95C463.5,370.72,455.84,378.37,446.4,378.37z"/>
		</svg>;
		break;
	case 'vertical':
		icon = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" >
			<path className="monitorShape" d="M105.67,433.97V37.63c0-9.44,7.65-17.09,17.09-17.09h250.95c9.44,0,17.09,7.65,17.09,17.09v396.33 c0,9.44-7.65,17.09-17.09,17.09H122.76C113.32,451.06,105.67,443.41,105.67,433.97z"/>
		</svg>;
		break;
	// TODO: Make 4k icons
	case 'horizontal_4k':
		icon = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" >
			<path className="monitorShape" d="M446.4,378.37H50.07c-9.44,0-17.09-7.65-17.09-17.09V110.32c0-9.44,7.65-17.09,17.09-17.09H446.4 c9.44,0,17.09,7.65,17.09,17.09v250.95C463.5,370.72,455.84,378.37,446.4,378.37z"/>
			<g>
				<path className="svgText" d="M201.27,285.4v-30.28h-51.66v-9.92l49.61-70.99h16.25v69.11h15.57v11.8h-15.57v30.28H201.27z M201.27,243.32 V206.2c0-5.82,0.17-11.63,0.51-17.45h-0.51c-3.42,6.5-6.16,11.29-9.24,16.42l-27.2,37.81v0.34H201.27z"/>
				<path className="svgText" d="M247.8,170.1h14.88v55.6h0.51c3.08-4.45,6.16-8.55,9.07-12.32l35.24-43.28h18.47l-41.74,48.93l44.99,66.37 H311.6l-37.98-56.62l-10.95,12.66v43.96H247.8V170.1z"/>
			</g>
		</svg>;
		break;
	case 'vertical_4k':
		icon = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500" >
			<path className="monitorShape" d="M105.67,433.97V37.63c0-9.44,7.65-17.09,17.09-17.09h250.95c9.44,0,17.09,7.65,17.09,17.09v396.33 c0,9.44-7.65,17.09-17.09,17.09H122.76C113.32,451.06,105.67,443.41,105.67,433.97z"/>
			<g>
				<path className="svgText" d="M201.27,285.4v-30.28h-51.66v-9.92l49.61-70.99h16.25v69.11h15.57v11.8h-15.57v30.28H201.27z M201.27,243.32 V206.2c0-5.82,0.17-11.63,0.51-17.45h-0.51c-3.42,6.5-6.16,11.29-9.24,16.42l-27.2,37.81v0.34H201.27z"/>
				<path className="svgText" d="M247.8,170.1h14.88v55.6h0.51c3.08-4.45,6.16-8.55,9.07-12.32l35.24-43.28h18.47l-41.74,48.93l44.99,66.37 H311.6l-37.98-56.62l-10.95,12.66v43.96H247.8V170.1z"/>
			</g>
		</svg>;
		break;
	case 'visual_content_loop_icon':
		icon = (
			<svg width="1.5em" height="1.5em" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
				<path d="m1167.6 565.2c-10.801-88.801-68.398-160.8-153.6-194.4-90-34.801-190.8-16.801-262.8 45.602l-114 99.602 57.602 50.398 105.6-93.602c50.398-44.398 122.4-56.398 186-32.398 58.801 22.801 98.398 73.199 105.6 133.2 1.1992 8.3984 1.1992 16.801 1.1992 25.199 0 8.3984-1.1992 16.801-1.1992 25.199-7.1992 61.199-46.801 110.4-105.6 133.2-63.602 24-133.2 12-183.6-30-1.1992-1.1992-1.1992-1.1992-2.3984-2.3984l-320.4-279.6-32.398-28.801c-72-62.398-171.6-80.398-262.8-45.602-84 33.602-142.8 105.6-152.4 194.4-2.3984 12-2.3984 22.801-2.3984 34.801 0 10.801 0 22.801 2.3984 33.602 10.801 88.801 68.398 162 153.6 194.4 90 34.801 190.8 16.801 262.8-45.602l32.398-28.801 44.398 44.398 12-150-153.6 9.6055 43.199 43.199-28.801 25.199c-50.398 44.398-121.2 56.398-186 32.398-58.801-22.801-98.398-72-105.6-133.2 0-8.3984-1.1992-16.801-1.1992-25.199s1.1992-18 1.1992-25.199c7.1992-60 46.801-110.4 105.6-133.2 21.602-8.3984 44.398-12 66-12 43.199 0 86.398 15.602 118.8 44.398l32.398 28.801 319.2 279.6 2.3984 1.1992c46.801 42 106.8 63.602 168 63.602 31.199 0 63.602-6 93.602-18 85.199-32.398 142.8-105.6 153.6-194.4 1.1992-10.801 2.3984-22.801 2.3984-33.602 1.2031-13.203 0.003906-24.004-1.1953-36.004z" fill="currentColor"/>
			</svg>
		);
		break;
	case 'visual_content_loop_icon_down_alligned':
		icon = (
			<svg width="1.5em" height="1.5em" viewBox="0 0 1200 800" xmlns="http://www.w3.org/2000/svg">
				<path d="m1167.6 565.2c-10.801-88.801-68.398-160.8-153.6-194.4-90-34.801-190.8-16.801-262.8 45.602l-114 99.602 57.602 50.398 105.6-93.602c50.398-44.398 122.4-56.398 186-32.398 58.801 22.801 98.398 73.199 105.6 133.2 1.1992 8.3984 1.1992 16.801 1.1992 25.199 0 8.3984-1.1992 16.801-1.1992 25.199-7.1992 61.199-46.801 110.4-105.6 133.2-63.602 24-133.2 12-183.6-30-1.1992-1.1992-1.1992-1.1992-2.3984-2.3984l-320.4-279.6-32.398-28.801c-72-62.398-171.6-80.398-262.8-45.602-84 33.602-142.8 105.6-152.4 194.4-2.3984 12-2.3984 22.801-2.3984 34.801 0 10.801 0 22.801 2.3984 33.602 10.801 88.801 68.398 162 153.6 194.4 90 34.801 190.8 16.801 262.8-45.602l32.398-28.801 44.398 44.398 12-150-153.6 9.6055 43.199 43.199-28.801 25.199c-50.398 44.398-121.2 56.398-186 32.398-58.801-22.801-98.398-72-105.6-133.2 0-8.3984-1.1992-16.801-1.1992-25.199s1.1992-18 1.1992-25.199c7.1992-60 46.801-110.4 105.6-133.2 21.602-8.3984 44.398-12 66-12 43.199 0 86.398 15.602 118.8 44.398l32.398 28.801 319.2 279.6 2.3984 1.1992c46.801 42 106.8 63.602 168 63.602 31.199 0 63.602-6 93.602-18 85.199-32.398 142.8-105.6 153.6-194.4 1.1992-10.801 2.3984-22.801 2.3984-33.602 1.2031-13.203 0.003906-24.004-1.1953-36.004z" fill="currentColor"/>
			</svg>
		);
		break;
	case 'arrow-turn-down-right':
		// Font Awesome Pro `arrow-turn-down-right` (solid). Not in the free
		// icon set, so it's embedded here rather than referenced by name.
		icon = (
			<svg width="1em" height="1em" viewBox="0 0 640 640" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ verticalAlign: '-0.125em' }}>
				<path fill="currentColor" d="M128 160C128 142.3 113.7 128 96 128C78.3 128 64 142.3 64 160L64 256C64 309 107 352 160 352L466.7 352L393.3 425.4C380.8 437.9 380.8 458.2 393.3 470.7C405.8 483.2 426.1 483.2 438.6 470.7L566.6 342.7C579.1 330.2 579.1 309.9 566.6 297.4L438.6 169.4C426.1 156.9 405.8 156.9 393.3 169.4C380.8 181.9 380.8 202.2 393.3 214.7L466.7 288L160 288C142.3 288 128 273.7 128 256L128 160z"/>
			</svg>
		);
		break;
	case 'is_custom':
		icon = <FontAwesomeIcon className="customCheckCircle" icon={'check-circle'}/>;
		break;
	case 'no-preview':
		icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500"><title>no-preview</title><path d="M72,69H1427V1432.92H72V69h0M1427,39H72A30,30,0,0,0,42,69V1432.92a30,30,0,0,0,30,30H1427a30,30,0,0,0,30-30V69a30,30,0,0,0-30-30Z"/><path d="M802.19,865.91A52.21,52.21,0,1,1,750,813.7,52.26,52.26,0,0,1,802.19,865.91ZM703.83,600.44l8.87,177.5a15.66,15.66,0,0,0,15.64,14.88h43.3a15.66,15.66,0,0,0,15.64-14.88l8.87-177.5A15.66,15.66,0,0,0,780.51,584h-61A15.66,15.66,0,0,0,703.83,600.44Z"/></svg>;
		break;
	default:
		if (props.size) {
			icon = <FontAwesomeIcon icon={props.icon} color={props.color} size={props.size}/>;
		} else {
			icon = <FontAwesomeIcon icon={props.icon} color={props.color}/>;
		}
	}

	return (
		<React.Fragment>
			{icon}
		</React.Fragment>
	);
}

export default CustomIcon;